"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSettingsResponseSchema = exports.AccountSettingsResultSchema = exports.AccountSettingsSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../schemas");
exports.AccountSettingsSchema = zod_1.default.object({
    email: zod_1.default.string().email(),
    firstName: zod_1.default.string().min(2).max(100),
    lastName: zod_1.default.string().min(2).max(100),
    openToCompanyOffer: zod_1.default.boolean().default(false),
    openToDirectMessage: zod_1.default.boolean().default(false),
    subscribedToNewsletter: zod_1.default.boolean().default(false),
});
exports.AccountSettingsResultSchema = zod_1.default.object({ settings: exports.AccountSettingsSchema });
exports.AccountSettingsResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.AccountSettingsResultSchema);
